/**
 * @generated SignedSource<<b96f2fd4ae7499f02664d37c6e170917>>
 * @relayHash bf88d4c0466128a4ce794c3291134145
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID fad9602cc939abe026957eedfb3768d995afeda6dc5cbfbcc894fd0a905f9013

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { JourneyConfigurationPageQuery } from './JourneyConfigurationPageQuery.graphql';

const node: PreloadableConcreteRequest<JourneyConfigurationPageQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "fad9602cc939abe026957eedfb3768d995afeda6dc5cbfbcc894fd0a905f9013",
    "metadata": {},
    "name": "JourneyConfigurationPageQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
